<template>
  <span>
    <v-dialog v-model="dialog" max-width="900">
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltipOn }">
            <v-icon
              color="info"
              size="18"
              class="mb-1 ml-1"
              v-bind="attrs"
              v-on="{ ...on, ...tooltipOn }"
            >
              mdi-help-circle
            </v-icon>
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </template>

      <v-card>
        <v-card-title class="text-h6 pb-2">
          {{ title }}
        </v-card-title>

        <v-card-text>
          <div class="body-2 grey--text text--darken-1 mb-4">
            {{ description }}
          </div>

          <v-container fluid class="pa-0">
            <v-row dense class="mb-4">
              <v-col
                v-for="faixa in faixas"
                :key="faixa.chave"
                cols="12"
                sm="6"
                md="4"
                lg="12"
                xl="12"
                class="d-flex"
              >
                <v-sheet
                  width="100%"
                  rounded="lg"
                  :style="{ backgroundColor: faixa.corSuave }"
                  class="pa-0 elevation-1"
                >
                  <div
                    class="px-4 py-2 text-center font-weight-bold"
                    :style="{ backgroundColor: faixa.cor, color: '#1f1f1f' }"
                  >
                    {{ faixa.label }}
                  </div>

                  <div class="pa-4 text-center">
                    <v-icon size="34" :color="faixa.cor" class="mb-2">
                      {{ faixa.icone }}
                    </v-icon>
                    <div class="subtitle-2 font-weight-bold">
                      {{ faixa.intervalo }}%
                    </div>
                    <div class="body-2 grey--text text--darken-2 mt-2">
                      {{ faixa.descricao }}
                    </div>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-divider class="mb-3" />

            <div class="subtitle-2 font-weight-medium mb-2">
              Leitura visual das faixas
            </div>

            <v-row dense align="center" no-gutters class="faixas-info__scale">
              <v-col
                v-for="faixa in faixas"
                :key="`${faixa.chave}-scale`"
                cols="12"
                sm="2"
                class="text-center"
              >
                <div
                  class="faixas-info__scale-bar"
                  :style="{ backgroundColor: faixa.cor }"
                />
                <v-icon size="28" :color="faixa.cor" class="mt-2 mb-1">
                  {{ faixa.icone }}
                </v-icon>
                <div class="caption font-weight-medium px-1">
                  {{ faixa.label }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { FAIXAS_ISFP_PSFP } from "@/utils/isfpPsfpFaixas";

export default {
  name: "DashboardIsfpPsfpFaixasInfo",
  props: {
    title: {
      type: String,
      default: "Faixas de valores do ISFP",
    },
    tooltip: {
      type: String,
      default: "Ver explicação das faixas de valores",
    },
    description: {
      type: String,
      default:
        "A classificação visual abaixo segue a mesma lógica de faixas usada na distribuição do dashboard.",
    },
  },
  data: () => ({
    dialog: false,
    faixas: FAIXAS_ISFP_PSFP,
  }),
};
</script>

<style scoped>
.faixas-info__scale {
  row-gap: 8px;
}

.faixas-info__scale-bar {
  width: 100%;
  height: 14px;
  border-radius: 999px;
}
</style>
